mutation UpdatePlatformPage($id: ID!, $input: UpdatePlatformPageInput!) {
  updatePlatformPage(id: $id, input: $input) {
    id
    title
    path
    url
    description
    publishAt
    isHomepage
    countryCodes
    image {
      id
      url(format: HIGH)
    }
    visibilityConditions {
      userType
      countries {
        type
        countryCodes
      }
      applicationPlatforms {
        type
        platforms
      }
    }
    blocks {
      id
      component
      props
      visibilityConditions {
        userType
        countries {
          type
          countryCodes
        }
        applicationPlatforms {
          type
          platforms
        }
      }
    }
  }
}

